module.exports = __webpack_public_path__ + "media/images/countrysquared/ma-2ed9894b8f8900afc8bc9114b1f0b96e.svg";